
import {useEffect, useState} from "react";

function SignUpPattern(props) {


    useEffect(() => {

    }, []);

    return (
        <div
            className="sign-up-pattern relative hidden md:block md:w-1/2 bg-wedges-purple-600 relative overflow-hidden">
            <svg className="absolute top-0 left-0" width="720" height="787" viewBox="0 0 720 787" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M-392.905 -502.476L-391.004 -501.739C-391.004 -501.739 326.491 -197.031 501.442 -56.8491C676.392 83.3324 662.208 352.981 508.59 506.599C354.972 660.217 85.3233 674.401 -54.8582 499.451C-195.04 324.5 -499.748 -392.994 -499.748 -392.994L-500.485 -394.895C-516.584 -436.403 -527.156 -463.658 -494.411 -496.402C-461.667 -529.146 -434.412 -518.575 -392.905 -502.476Z"
                    fill="#282A35"></path>
            </svg>
            <svg className="absolute top-0 left-0" width="392" height="487" viewBox="0 0 392 487" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M-336.818 -308.216L-335.645 -307.762C-335.645 -307.762 106.836 -120.048 214.706 -33.6373C322.576 52.7737 313.735 219.111 218.923 313.922C124.112 408.734 -42.2253 417.575 -128.636 309.705C-215.047 201.835 -402.761 -240.646 -402.761 -240.646L-403.215 -241.819C-413.132 -267.417 -419.644 -284.226 -399.434 -304.435C-379.225 -324.644 -362.416 -318.133 -336.818 -308.216Z"
                    fill="#373a48"></path>
            </svg>
            <svg className="absolute bottom-0 left-0" width="632" height="316" viewBox="0 0 632 316" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M-351.418 900.397L-350.856 898.948C-350.856 898.948 -118.665 351.944 -11.8154 218.578C95.0341 85.2126 300.633 96.0786 417.79 213.235C534.947 330.392 545.813 535.991 412.447 642.841C279.081 749.69 -267.923 981.882 -267.923 981.882L-269.372 982.444C-301.016 994.711 -321.795 1002.77 -346.768 977.793C-371.74 952.821 -363.685 932.042 -351.418 900.397Z"
                    fill="#17181c"></path>
            </svg>
            <svg className="absolute bottom-0 right-0" width="477" height="768" viewBox="0 0 477 768" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M334.917 239.653L336.582 240.299C336.582 240.299 965.06 507.074 1118.29 629.839C1271.52 752.603 1259.04 988.825 1124.43 1123.43C989.823 1258.04 753.6 1270.52 630.836 1117.29C508.071 964.063 241.296 335.585 241.296 335.585L240.65 333.92C226.556 297.562 217.301 273.688 245.993 244.996C274.685 216.304 298.559 225.559 334.917 239.653Z"
                    fill="#373a48"></path>
            </svg>

            {<div className="review">
                <div className="shadow-menu">
                    <p className="text">Mocky is a web based api mock service. No setup. Intercept and modify any
                        request.</p>
                    <ul>
                        <li>Test any API</li>
                        <li>Custom subdomains</li>
                        <li>No account required, get started now</li>
                    </ul>
                </div>
            </div>}
        </div>
    );
}

export default SignUpPattern;
